<template>
  <div class="prepareLessons">
    <div class="topTitle">
      <span style="cursor: pointer;" @click="gobanck1">返回</span> /
      {{ teamMessage.teamInfo.title }}
    </div>
    <div class="mian">
      <el-row :gutter="10" style="">
        <el-col :span="16">
          <div style="background:white;padding:20px; border-radius: 5px;">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="概况" name="second">
                <div>
                  <div style="font-weight:bold;margin-top:10px;">团队数据</div>
                  <el-card style="margin-top: 20px;" shadow="never">
                    <div>
                      <ul class="clearfix dataTop">
                        <li class="fl">
                          <div class="clearfix">
                            <div class="fl dataPic">
                              <img
                                src="https://wugecdn.steam.fun/resources/static/oj/people.png"
                                width="100%"
                              />
                            </div>
                            <div class="fl dataTxt">
                              <div>成员数</div>
                              <div style="margin-top: 5px; font-weight: bold;">
                                <span v-if="totalTeamStuNum === null">--</span>
                                <span v-else>{{ totalTeamStuNum }}</span>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="fl">
                          <div class="clearfix">
                            <div class="fl dataPic">
                              <img
                                src="https://wugecdn.steam.fun/resources/static/oj/tidan.png"
                                width="100%"
                              />
                            </div>
                            <div class="fl dataTxt">
                              <div>题单数</div>
                              <div style="margin-top: 5px; font-weight: bold;">
                                <span v-if="totalTeamProblemListNum === null"
                                  >--</span
                                >
                                <span v-else>{{
                                  totalTeamProblemListNum
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="fl">
                          <div class="clearfix">
                            <div class="fl dataPic">
                              <img
                                src="https://wugecdn.steam.fun/resources/static/oj/timu.png"
                                width="100%"
                              />
                            </div>
                            <div class="fl dataTxt">
                              <div>题目数</div>
                              <div style="margin-top: 5px; font-weight: bold;">
                                <span v-if="totalTeamProblemNum === null"
                                  >--</span
                                >
                                <span v-else>{{ totalTeamProblemNum }}</span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </el-card>
                  <div style="margin-top: 20px;">
                    <div class="clearfix">
                      <div class="fl" style="font-weight: bold;">提交统计</div>
                      <div class="fr">
                        <el-date-picker
                          @change="chengTime"
                          style="width:280px;"
                          size="mini"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          v-model="formTime.outWarehouseTimeLine1"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          placement="bottom-start"
                        >
                        </el-date-picker>
                      </div>
                      <!-- <div class="fr">
                        <el-form @submit.native.prevent ref="form" :inline="true" :model="formstu" label-width=""
                          size="mini">
                          <el-form-item label="学员姓名">
                            <el-input v-model="formstu.name" clearable placeholder="请输入学员姓名"></el-input>
                          </el-form-item>
                        </el-form>
                      </div> -->
                    </div>
                    <div style="width: 100%; height: calc(100vh - 423px);">
                      <el-empty
                        v-if="dataListTotal.length === 0"
                        description="暂无数据"
                      ></el-empty>
                      <div
                        v-if="dataListTotal.length != 0"
                        style="width: 100%; height: 100%;"
                        id="myChart1"
                      ></div>
                      <!-- <div style="width: 100%; height: 100%;" id="myChart1"></div> -->
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="团队题单" name="third">
                <div style="height: calc(100vh - 245px);">
                  <el-table
                    height="calc(100% - 53px)"
                    :data="tableData2"
                    style="width: 100%;"
                    :header-cell-style="{
                      background: '#f5f7fa',
                      color: '#333',
                      'font-size': '14px',
                    }"
                  >
                    <el-table-column prop="title" label="序号" width="55">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="title"
                      label="题单名称"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.problemListInfo.title }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="problemListInfo.problem_num"
                      label="题目数量"
                      width="100"
                    >
                    </el-table-column>
                    <el-table-column prop="" label="题单类型">
                      <template slot-scope="scope">
                        <span
                          v-if="
                            scope.row.problemListInfo
                              .oj_problem_list_type_id === null
                          "
                          >--</span
                        >
                        <span v-else>
                          <span>{{
                            scope.row.problemListInfo.totalInfo.title
                          }}</span>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="created_time" label="添加时间">
                    </el-table-column>

                    <el-table-column
                      prop="problemListInfo.problem_num"
                      label="完成度"
                    >
                      <template slot-scope="scope">
                        <el-progress
                          :text-inside="true"
                          :stroke-width="15"
                          :percentage="
                            setItemProgress(scope.row.problemListInfo)
                          "
                          :format="setItemText(scope.row.problemListInfo)"
                        ></el-progress>
                      </template>
                    </el-table-column>

                    <el-table-column prop="" label="操作" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          size="mini"
                          @click="goProblem(scope.row.problemListInfo)"
                          >查看</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div style="margin: 20px; text-align: right">
                    <el-pagination
                      @current-change="handleCurrent2"
                      :current-page="page_no2"
                      :page-size="page_size2"
                      layout="total, prev, pager, next, jumper"
                      :total="total2"
                    >
                    </el-pagination>
                  </div>
                </div>
              </el-tab-pane>
              <!-- <el-tab-pane label="团队成员" name="fourth">
                <div style="height: calc(100vh - 245px);">
                  <el-table size="small" :data="tableData" stripe style="width: 100%; "
                    :header-cell-style="{ background: '#f5f7fa', color: '#909399', 'font-size': '14px' }">

                    <el-table-column width="100" label="头像" align="center">
                      <template slot-scope="scope">
                        <el-image style="width: 30px; height: 30px" :src="scope.row.headImgUrl" fit="cover"></el-image>
                      </template>
                    </el-table-column>

                    <el-table-column prop="realname" label="姓名">

                    </el-table-column>

                    <el-table-column prop="sex" label="性别">

                    </el-table-column>

                  </el-table>
                  <div style="margin: 20px; text-align: right">
                    <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size"
                      layout="total, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                  </div>
                </div>

              </el-tab-pane> -->
            </el-tabs>
          </div>
        </el-col>
        <el-col :span="8">
          <div
            class="right_top"
            style="background:white; border-radius: 5px; max-height: 96px;"
          >
            <div class="clearfix">
              <div style="font-weight:bold;">
                <svg
                  style="float:left;margin-right:10px;"
                  t="1658450998090"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="11846"
                  width="18"
                  height="18"
                >
                  <path
                    d="M232.0384 648.06912l2.08896 0.8192 197.38624 63.16032 61.56288 213.1968a72.74496 72.74496 0 0 1-10.48576 62.01344 68.11648 68.11648 0 0 1-23.79776 20.76672c-9.4208 4.9152-19.74272 7.45472-30.26944 7.45472-26.2144 0-51.65056-8.76544-72.66304-25.02656a126.68928 126.68928 0 0 1-43.90912-65.20832l-79.872-277.17632z m649.216-574.6688c12.00128 0 23.51104 4.95616 31.98976 13.80352 8.47872 8.8064 13.27104 20.80768 13.27104 33.30048v706.56c0 12.4928-4.79232 24.45312-13.27104 33.30048a44.40064 44.40064 0 0 1-31.98976 13.80352c-12.04224 0-23.552-4.95616-32.03072-13.80352a48.128 48.128 0 0 1-13.27104-33.30048V120.50432c0-12.4928 4.79232-24.49408 13.27104-33.30048 8.47872-8.84736 19.98848-13.80352 32.03072-13.80352z m-90.5216 94.208v612.352l-588.5952-188.416v-235.52l588.5952-188.416zM156.8768 356.02432v235.52H111.616c-12.00128 0-23.51104-4.95616-31.98976-13.80352a48.08704 48.08704 0 0 1-13.27104-33.30048v-141.312c0-12.4928 4.75136-24.49408 13.27104-33.30048 8.47872-8.84736 19.98848-13.80352 31.98976-13.80352H156.8768z"
                    fill="#2E78DD"
                    p-id="11847"
                  ></path>
                </svg>
                <span style="float:left;line-height:18px;margin-right:10px;">
                  团队公告
                </span>
              </div>
            </div>
            <div style="margin-top:20px;">
              <span class="clearfix">
                <span
                  class="fl"
                  style="width: calc(100% - 67px);text-overflow: -o-ellipsis-lastline;overflow: hidden;	text-overflow: ellipsis;	display: -webkit-box;-webkit-line-clamp: 1;line-clamp: 1;-webkit-box-orient: vertical;	"
                >
                  <span v-if="teamMessage.teamInfo.notic == ''">暂无公告</span>
                  <span v-html="teamMessage.teamInfo.notic"></span>
                </span>
                <span
                  v-if="teamMessage.teamInfo.notic != ''"
                  class="fr"
                  style="line-height: 18px;font-size: 14px;cursor: pointer;"
                  @click="moreTxt"
                  >更多...</span
                >
              </span>
            </div>
          </div>
          <div>
            <div
              class="right_top"
              style="background:white; margin-top: 10px;border-radius: 5px 5px 0px 0px"
            >
              <div
                class="clearfix"
                style="padding: 0 20px;margin-top: 30px;margin-left: 10%;"
              >
                <div
                  class="fl"
                  style="width: 33%;height: 63px; margin-right: -5%;position: relative;bottom: -22px;"
                >
                  <img
                    src="https://wlmvp-cos.weiling.cn/worktable-h5/icon/top2_bg.png"
                    style="width: 100%;height: 100%; "
                  />
                  <div
                    v-if="userde != undefined"
                    style="position: absolute; top: 50%; left: 50%;  transform: translate(-50%, -50%);"
                  >
                    <div>{{ userde.name }}</div>
                    <div style="text-align: center;font-weight:bold;">
                      {{ userde.pass_count }}
                    </div>
                  </div>
                  <div
                    v-if="userde != undefined"
                    style="position: absolute;top:-35px;left: 50%;margin-left: -20px;"
                  >
                    <div class="dierBox2">
                      <img :src="userde.headImgUrl" style="width: 100%;" />
                    </div>
                    <div style="position: absolute;top: -8px;right: -5px;">
                      <img
                        src="../../../assets/image/top2.png"
                        style="width: 20px;"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="fl"
                  style="width: 33%; height: 85px; position: relative ;z-index: 999;"
                >
                  <img
                    src="https://wlmvp-cos.weiling.cn/worktable-h5/icon/top1_bg.png"
                    style="width: 100%; height: 100%;"
                  />
                  <div
                    v-if="userdy != undefined"
                    style="position: absolute; top: 50%; left: 50%;  transform: translate(-50%, -50%);"
                  >
                    <div>{{ userdy.name }}</div>
                    <div style="text-align: center;font-weight:bold;">
                      {{ userdy.pass_count }}
                    </div>
                  </div>
                  <div
                    v-if="userdy != undefined"
                    style="position: absolute;top:-30px;left: 50%;margin-left: -20px;"
                  >
                    <div class="dierBox1">
                      <img :src="userdy.headImgUrl" style="width: 100%;" />
                    </div>
                    <div style="position: absolute;top: -8px;right: -5px;">
                      <img
                        src="../../../assets/image/top1.png"
                        style="width: 20px;"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="fl"
                  style="width: 33%;height: 40px; margin-left: -5%;position: relative ;bottom:-45px"
                >
                  <img
                    src="https://wlmvp-cos.weiling.cn/worktable-h5/icon/top3_bg.png"
                    style="width: 100%;height: 100%;"
                  />
                  <div
                    v-if="userds != undefined"
                    style="position: absolute; top: 50%; left: 50%;  transform: translate(-50%, -50%);font-size: 10px;"
                  >
                    <div>{{ userds.name }}</div>
                    <div style="text-align: center;font-weight:bold;">
                      {{ userds.pass_count }}
                    </div>
                  </div>
                  <div
                    v-if="userds != undefined"
                    style="position: absolute;top:-38px;left: 50%;margin-left: -20px;"
                  >
                    <div class="dierBox3">
                      <img :src="userds.headImgUrl" style="width: 100%;" />
                    </div>
                    <div style="position: absolute;top: -8px;right: -5px;">
                      <img
                        src="../../../assets/image/top3.png"
                        style="width: 20px;"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tableContent"
            style="width: 100%;height: calc(100vh - 411px); background: #fff; overflow-y: auto;"
          >
            <el-table
              highlight-current-row
              ref="singleTable"
              v-el-table-infinite-scroll="loadTable"
              :data="tableDataSoltUser"
              :header-cell-style="{ background: '#f3f7fb', color: '#333' }"
              style="width: 100%"
              height="100%"
            >
              <el-table-column prop="date" label="排名" align="center">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
              </el-table-column>
              <el-table-column prop="" label="头像">
                <template slot-scope="scope">
                  <div
                    style="width: 30px; height: 30px; overflow: hidden; border-radius: 50%;"
                  >
                    <img :src="scope.row.headImgUrl" style="width: 100%;" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="姓名">
                <template slot-scope="scope">
                  <span
                    :class="
                      scope.row.stu_user_id === $store.state.user.userInfo.id
                        ? 'colorTxtStyle'
                        : ''
                    "
                    >{{ scope.row.name }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column prop="pass_count" label="AC数">
              </el-table-column>
              <el-table-column prop="submit_count" label="提交量">
              </el-table-column>
            </el-table>

            <!-- <el-alert v-if="isMore" title="没有更多啦！" type="warning" center show-icon>
          </el-alert> -->
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog title="团队公告" :visible.sync="moretxt" width="40%">
      <div style="max-height:50vh;overflow-y:scroll">
        <span v-html="teamMessage.teamInfo.notic"></span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
// import Sortable from 'sortablejs';

import {
  stuGetTeamStuList,
  stuGetProblemForTeam,
  stuGetProblemListForTeam,
  tchGetTeamStuRank,
  tchGetTeamTotalData,
  ojStuGetTeamSubmissiont,
} from '@/api/educational.js'

export default {
  data() {
    return {
      dataListTotal: [],
      moretxt: false,
      userdy: {},
      userde: {},
      userds: {},
      //统计时间
      formTime: {
        outWarehouseTimeLine1: [
          moment()
            .subtract(7, 'days')
            .format('YYYY-MM-DD'),
          moment()
            .subtract(1, 'days')
            .format('YYYY-MM-DD'),
        ],
      },
      totalTeamStuNum: null,
      totalTeamProblemNum: null,
      totalTeamProblemListNum: null,
      tableDataSoltUser: [],
      tableDataSoltUser1: [],
      page_noSolt: 1,
      page_sizeSolt: 20,
      totaSolt: 0,
      isMore: false,
      isflag: false,
      //题单
      tableData2: [],
      page_no2: 1,
      page_size2: 20,
      total2: 1,
      // 题目
      page_no1: 1,
      page_size1: 20,
      total1: 20,
      tableData1: [],

      activeName: 'second',
      teamMessage: {},
      addForm: {},
      dialogVisible: false,
      keyword: '',
      page_no: 1,
      page_size: 10,
      total: 1,
      form: {
        resource: '',
      },
      activeClass: 0,

      tableData: [],
      showTxt: '',
    }
  },
  created() {
    this.teamMessage = JSON.parse(this.$route.query.team)
    if (this.$route.query.activeName === undefined) {
      console.log(121212, 121245)
    } else {
      this.activeName = this.$route.query.activeName
      if (this.$route.query.activeName === 'second') {
        this.page_no1 = this.$route.query.page_no
        this.page_size1 = this.$route.query.page_size
        // this.stuGetProblemForTeam()
        this.tchGetTeamStuRank()
      }
      console.log(this.$route.query.activeName, 12121545121)
      if (this.$route.query.activeName === 'third') {
        this.page_no1 = this.$route.query.page_no
        this.page_size1 = this.$route.query.page_size
        this.stuGetProblemListForTeam()
        this.tchGetTeamStuRank()

        // this.tchGetProblemListForTeam()
      }
    }
  },
  mounted() {
    console.log(this.$store.state.user.userInfo.id, 232323)
    // console.log(this.$sta);
    // this.stuGetProblemForTeam()
    // this.stuGetProblemListForTeam()
    if (this.activeName === 'second') {
      this.tchGetTeamTotalData()
      this.tchGetTeamStuRank()
      this.$nextTick(() => {
        this.ojStuGetTeamSubmissiont()
        // this.drawLine1()
      })
    }
  },

  methods: {
    chengTime() {
      this.ojStuGetTeamSubmissiont()
    },
    ojStuGetTeamSubmissiont() {
      ojStuGetTeamSubmissiont({
        team_id: this.teamMessage.oj_team_id,
        start_date: this.formTime.outWarehouseTimeLine1[0],
        end_date: this.formTime.outWarehouseTimeLine1[1],
      }).then((res) => {
        console.log(res, 5641212)
        console.log(res, 11212)
        this.dataListTotal = res.returnDate
        let time = []
        let pass = []
        let submit = []
        res.returnDate.map((item) => {
          // time.push(item.count_date)
          // time.push(item.count_date.slice(0, item.count_date.length - 9))
          time.push(item.count_date.substring(0, 10))

          pass.push(item.pass_count)
          submit.push(item.submit_count)
        })
        console.log(time, 11212)
        console.log(pass, 11212)
        console.log(submit, 11212)
        this.$nextTick(() => {
          this.drawLine1(time, pass, submit)
        })
      })
    },
    moreTxt() {
      this.moretxt = true
    },
    tchGetTeamTotalData() {
      tchGetTeamTotalData({
        team_id: this.teamMessage.oj_team_id,
      }).then((res) => {
        console.log(res, 452321)
        this.totalTeamStuNum = res.totalTeamStuNum
        this.totalTeamProblemNum = res.totalTeamProblemNum
        this.totalTeamProblemListNum = res.totalTeamProblemListNum
      })
    },
    //排名
    tchGetTeamStuRank() {
      this.tableDataSoltUser1 = []

      // this.tableLoading = true;
      tchGetTeamStuRank({
        team_id: this.teamMessage.oj_team_id,
        page_no: this.page_noSolt,
        page_size: this.page_sizeSolt,
      }).then((res) => {
        console.log(res, 5465323)
        // this.tableDataSoltUser = []
        this.tableDataSoltUser1 = res.returnData
        this.tableDataSoltUser.push(...this.tableDataSoltUser1)
        this.userdy = this.tableDataSoltUser[0]
        this.userde = this.tableDataSoltUser[1]
        console.log(this.userde, 562323)
        this.userds = this.tableDataSoltUser[2]
        this.totaSolt = res.total

        this.tableDataSoltUser.map((item, index) => {
          this.showTxt = this.$store.state.user.userInfo.id
          if (item.stu_user_id === this.$store.state.user.userInfo.id) {
            console.log(index, 1323232)
            this.$refs.singleTable.setCurrentRow(this.tableDataSoltUser[index])
          }
        })
        // scope.row.stu_user_id === $store.state.user.userInfo.id
        // this.$nextTick(() => {

        // })
      })
    },
    loadTable() {
      if (this.tableDataSoltUser1.length < this.page_sizeSolt) {
        console.log(this.tableDataSoltUser1.length, 56233)
        console.log(111)
      } else {
        this.page_noSolt += 1
        this.tchGetTeamStuRank()
        this.isMore = true
      }
    },
    //概况
    drawLine1(time, pass, submit) {
      // 基于准备好的dom，初始化echarts实例
      // let myChart1 = this.$echarts.init(document.getElementById("myChart1"));
      let b = document.getElementById('myChart1')
      b.removeAttribute('_echarts_instance_')
      let myChart1 = this.$echarts.init(b)
      // 绘制员工数
      myChart1.setOption({
        title: { text: '' },
        tooltip: {},
        xAxis: {
          data: time,
        },
        legend: {
          data: ['AC数', '提交量'],
        },
        yAxis: {},
        series: [
          {
            name: 'AC数',
            type: 'line',
            data: pass,
          },
          {
            name: '提交量',
            type: 'line',
            data: submit,
          },
        ],
      })
    },

    setItemProgress(data) {
      if (data.problemAcceptNum > data.problem_num) {
        return 100
      } else {
        return parseInt(
          (data.problemAcceptNum / data.problem_num).toFixed(1) * 100
        )
      }
    },
    setItemText(data) {
      return () => {
        return data.problemAcceptNum + ' / ' + data.problem_num
      }
    },
    gobanck1() {
      this.$router.push({
        name: 'teamStu',
      })
    },
    handleClick(val) {
      if (val.name === 'second') {
        this.tableDataSoltUser1 = []
        this.tableDataSoltUser = []
        this.page_noSolt = 1

        this.tchGetTeamTotalData()
        this.tchGetTeamStuRank()
        this.$nextTick(() => {
          // this.drawLine1()
          this.ojStuGetTeamSubmissiont()
        })
      }
      if (val.name === 'fourth') {
        this.tableDataSoltUser1 = []
        this.tableDataSoltUser = []
        this.page_noSolt = 1

        this.tchGetTeamStuRank()

        this.stuGetTeamStuList()
      }

      if (val.name === 'third') {
        this.tableDataSoltUser1 = []
        this.tableDataSoltUser = []
        this.page_noSolt = 1

        this.tchGetTeamStuRank()

        this.stuGetProblemListForTeam()
      }
    },
    //题单
    stuGetProblemListForTeam() {
      stuGetProblemListForTeam({
        team_id: this.teamMessage.oj_team_id,
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        this.tableData2 = res.ojTeamProblemListRelationList
        this.total2 = res.total
        // this.tableData2[0].problemListInfo.problemAcceptNum = 3
        this.tableData2.forEach((item) => {
          item.problemListInfo.correlationId = item.id
        })
        console.log(res)
      })
    },
    handleCurrent2(val) {
      this.page_no2 = val
      this.stuGetProblemListForTeam()
    },
    goProblem(row) {
      console.log(row, 45623)
      sessionStorage.setItem('description', row.description)

      sessionStorage.setItem('tidan', row.title)

      this.$router.push({
        name: 'teamListOfUestionsList',
        query: {
          // problemlist_id: row.id,
          teamProblemlistRelationId: row.correlationId,
          practice: 'practice',
          title: row.title,
          problemAcceptNum: row.problemAcceptNum,
          problem_num: row.problem_num,
          educational_institution_id: row.educational_institution_id,
          description: row.description,
          page_no: this.page_no2,
          page_size: this.page_size2,
          team: this.$route.query.team,
          type: 'tuandui2',
        },
      })
    },
    //题目
    stuGetProblemForTeam() {
      stuGetProblemForTeam({
        team_id: this.teamMessage.oj_team_id,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log('学生作答')
        console.log(res)

        console.log(res)
        this.tableData1 = res.ojProblemList
        this.total1 = res.total
      })
    },
    goNext(row) {
      this.$router.push({
        name: 'questionBankDetails',
        query: {
          id: row.id,
          type1: 'tuanduiStu',
          page_no: this.page_no1,
          page_size: this.page_size1,
          team: JSON.stringify(this.teamMessage),
        },
      })
    },

    handleCurrent1(val) {
      this.page_no1 = val
      this.stuGetProblemForTeam()
    },
    stuGetTeamStuList() {
      stuGetTeamStuList({
        team_id: this.teamMessage.oj_team_id,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res)
        this.tableData = res.ojTeamStuRelatiohList
        this.total = res.total
      })
    },

    handleCurrent(val) {
      this.page_no = val
      this.stuGetTeamStuList()
    },
  },
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
<style scoped lang="scss">
.topTitle {
  height: 60px;
  background: #fff;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.prepareLessons {
  margin: 10px;
  min-height: calc(100vh - 120px);
  //   background: #ccc;
  border-radius: 5px;
  overflow: hidden;
}

.top {
  padding: 20px;
  padding-bottom: 0px;
  font-size: 18px;
  font-weight: 300;
  background: #fff;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
}

/deep/ .el-dropdown-link {
  cursor: pointer;
  color: #333;
}

.line {
  height: 50px;
  width: 2px;
  background: #999;
  margin: 0 20px;
}

.top li {
  cursor: pointer;
  float: left;
  margin-right: 20px;
}

.active {
  color: #41b146;
}

.topFrom ::v-deep .el-form-item {
  margin-bottom: 0px;
}

.mian {
  min-height: calc(100vh - 150px);
  margin-top: 10px;
  border-radius: 5px;
  box-sizing: border-box;
}

.right_top {
  padding: 20px;
}

.right_top li {
  margin-bottom: 20px;
}

.txt {
  font-size: 16px;
  font-weight: bold;
}

.left {
  padding: 20px;
}

.dataTop li {
  width: 33%;
}

.dataPic {
  width: 40px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
  // background-image: url("https://example.com/image.jpg");
  background-position: center center;
}

.dataTxt {
  margin-left: 10px;
}

.dierBox2 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #c3d3df;
  overflow: hidden;
}

.dierBox1 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #fdd98d;
  overflow: hidden;
}

.dierBox3 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #eaa989;
  overflow: hidden;
}

/deep/ .el-date-editor .el-range-separator {
  padding: 0 16px;
}

/deep/.el-dialog {
  border-radius: 10px !important;
}

.colorTxtStyle {
  color: #2ea1fb;
  // font-weight: bold;
  font-weight: bold;
  font-size: 14px;
  font-weight: 600;
  margin-left: 0px;
  line-height: 34px;
}

/deep/ .el-table__body tr.current-row > td.el-table__cell {
  background-color: #fff3d9;
}
</style>
